import { render, staticRenderFns } from "./LpuPrices.vue?vue&type=template&id=68340b2e&"
import script from "./LpuPrices.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuPrices.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68340b2e')) {
      api.createRecord('68340b2e', component.options)
    } else {
      api.reload('68340b2e', component.options)
    }
    module.hot.accept("./LpuPrices.vue?vue&type=template&id=68340b2e&", function () {
      api.rerender('68340b2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuPrices.vue"
export default component.exports